import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { MdChevronRight } from 'react-icons/md';
import { CategoryComponents } from '@app/components/header/components/HeaderSearch/HeaderSearch';
import { BaseList } from '@app/components/common/BaseList/BaseList';
import { CATEGORY_ICON, CATEGORY_LABEL } from '@app/constants/categoryIcons';
import { CategoryType } from '@app/constants/categoriesList';
import * as S from './SearchResults.styles';

interface SearchResultsProps {
  results: CategoryComponents[];
}

export const SearchResults: React.FC<SearchResultsProps> = ({ results }) => {
  const resultsList = useMemo(
    () =>
      results.map((result) => {
        const cat = result.category as CategoryType;
        return (
          <BaseList
            key={result.category}
            split={false}
            header={
              <S.CategoryHeader>
                {CATEGORY_ICON[cat]}
                <span>{CATEGORY_LABEL[cat] ?? result.category}</span>
              </S.CategoryHeader>
            }
            dataSource={result.components}
            renderItem={(item) => (
              <Link to={item.url}>
                <BaseList.Item>
                  <S.ResultLink>
                    <span className="result-icon">{CATEGORY_ICON[cat]}</span>
                    <S.Text>{item.name}</S.Text>
                    <MdChevronRight className="result-chevron" />
                  </S.ResultLink>
                </BaseList.Item>
              </Link>
            )}
          />
        );
      }),
    [results],
  );

  return <S.SearchResultsWrapper>{resultsList}</S.SearchResultsWrapper>;
};
